import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { destroy2, post2, put2 } from "../axios";
import { errorToast } from "../utils/helpers";
import useFranchiseHook from "./useFranchiseHook";
import { useTranslation } from "react-i18next";

const useThemeHook = () => {
  const [franchiseId] = useFranchiseHook();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const postTheme = useMutation({
    mutationFn: (data: any) => {
      return post2(
        `/internal/secure/pos/v1/websites/themes/${franchiseId}`,
        data
      );
    },
    onSuccess: () => {
      toast.success(t("success.success"));
      queryClient.refetchQueries({ queryKey: ["themes"] });
    },
    onError: () => {
      errorToast();
    },
  });

  const putTheme = useMutation({
    mutationFn: ({ data, id }: { data: any; id: string }) =>
      put2(
        `internal/secure/pos/v1/websites/themes/${franchiseId}/${id}`,
        data,
        {}
      ),
    onSuccess: () => {
      toast.success(t("success.update"));
      queryClient.refetchQueries({ queryKey: ["themes"] });
    },
    onError: () => {
      errorToast();
    },
  });

  const removeTheme = useMutation({
    mutationFn: (id: number) =>
      destroy2(`internal/secure/pos/v1/websites/themes/${franchiseId}/${id}`),
    onSuccess: async () => {
      toast.success("Extra verwijdert", {
        position: "bottom-right",
      });
      queryClient.refetchQueries({ queryKey: ["themes"] });
    },
    onError: async () => {
      errorToast();
    },
  });

  return { postTheme, putTheme, removeTheme };
};

export default useThemeHook;
